
    import Component from "vue-class-component";
    import Vue from "vue";   
    import {Prop} from "vue-property-decorator";
    import {IApprovalActions} from "@/features/shared/components/sections/ApprovalActions";
    import ConfirmWithCommentModal from "@/features/shared/components/ConfirmWithCommentModal.vue";
    import ConfirmWithInvalidationReasonAndCommentModal
      from "@/features/shared/components/ConfirmWithInvalidationReasonAndCommentModal.vue";
    import {ManualInvalidationReason, SuspensionReason, SuspensionReasonModel} from "@/api-client";
    import SuspensionModal from "@/features/endorsements/components/SuspensionModal.vue";
	import {ls} from "@/CultureService";

    @Component({ 
      components: {
        ConfirmWithCommentModal,
        ConfirmWithInvalidationReasonAndCommentModal,
        SuspensionModal
      }})
    export default class ApprovalActions extends Vue {
      
      @Prop({ default: () => { return; }})
      actions!: IApprovalActions;

      @Prop()
      approveAction!: () => Promise<void>;
    
      @Prop()
      disapproveAction!: (comment:string, reason?:ManualInvalidationReason) => Promise<string>;

      @Prop()
      suspendAction!: (comment : string, reason : SuspensionReason, startedOn : Date, validUntil : Date | null) => Promise<undefined>;

      @Prop()
      suspendOptions!: () => Promise<SuspensionReasonModel[]>;
      
      @Prop({default: false})
      requireReason! : boolean;
      
      @Prop({default: ls.Global_Button_Approve})
      approvalText! : string;

      $refs!: { rejectModal: ConfirmWithCommentModal }
      
      async handleApprove() {
        await this.approveAction();
      }

      async handleDisapprove(comment: string) {
        await this.disapproveAction(comment);
      }
      
      async handleDisapproveWithReason(comment: string, reason: ManualInvalidationReason){
        await this.disapproveAction(comment, reason);
      }
      
      async handleSuspension(comment : string, reason : SuspensionReason, startedOn : Date, validUntil : Date | null){
        await this.suspendAction(comment, reason, startedOn, validUntil);
      }
    }   
 
